import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';

import { Placeholder } from '@/tools/models/class-builder.models';

@Component({
  name: 'ed-class-builder-placeholder-block',
})
export default class EdClassBuilderPlaceholderBlockComponent extends Vue {
  @Prop({ default: null }) readonly placeholder: Placeholder;
  @Prop({ default: false }) readonly hasMoreThanOnePlaceholder: boolean;

  @Emit('zoom')
  emitZoom() {
    return this.placeholder;
  }
}